import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {SolutionOnboardingComponent} from '../solution-onboarding/solution-onboarding.component';
import {ToolbarButton} from '../../models/toolbar-button/toolbar-button';
import { SolutionSummaryComponent } from './solution-summary/solution-summary.component';
import { SolutionVersionsComponent } from './solution-versions/solution-versions.component';
import { ExternalPackageComponent } from './external-package/external-package.component';

const routes: Routes = [
  {
    path: '',
    component: SolutionOnboardingComponent,
    data: {
      activeLink: ToolbarButton.CATALOGUE
    },
    title: 'Solution',
  },
  {
    path: ':solutionId',
    component: SolutionSummaryComponent,
  },
  {
    path: ':solutionId/versions',
    component: SolutionVersionsComponent,
  },
  {
    path: ':solutionId/external-package',
    component: ExternalPackageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SolutionOnboardingRoutingModule {
}
